import "/__w/1/s/BotFramework-WebChat/packages/component/src/Activity/CarouselLayout.module_built.css";
const classes = {"carousel-layout":"wtvQgqa_carousel-layout"}
export default classes

const _carousel_layout0 = classes["carousel-layout"]
export { _carousel_layout0 as "carousel-layout" }
